uniform mat4 projectionMatrix;
uniform mat4 viewMatrix;
uniform mat4 modelMatrix;
uniform vec2 uFrequency;
uniform float uTime;

attribute vec3 position;
attribute vec2 uv;

varying vec2 vUv;
varying float vElevation;

// Simplex 2D noise
vec3 permute(vec3 x) { return mod(((x*34.0)+1.0)*x, 289.0); }

float snoise(vec2 v){
  const vec4 C = vec4(0.211324865405187, 0.366025403784439,
           -0.577350269189626, 0.024390243902439);
  vec2 i  = floor(v + dot(v, C.yy) );
  vec2 x0 = v -   i + dot(i, C.xx);
  vec2 i1;
  i1 = (x0.x > x0.y) ? vec2(1.0, 0.0) : vec2(0.0, 1.0);
  vec4 x12 = x0.xyxy + C.xxzz;
  x12.xy -= i1;
  i = mod(i, 289.0);
  vec3 p = permute( permute( i.y + vec3(0.0, i1.y, 1.0 ))
  + i.x + vec3(0.0, i1.x, 1.0 ));
  vec3 m = max(0.5 - vec3(dot(x0,x0), dot(x12.xy,x12.xy),
    dot(x12.zw,x12.zw)), 0.0);
  m = m*m ;
  m = m*m ;
  vec3 x = 2.0 * fract(p * C.www) - 1.0;
  vec3 h = abs(x) - 0.5;
  vec3 ox = floor(x + 0.5);
  vec3 a0 = x - ox;
  m *= 1.79284291400159 - 0.85373472095314 * ( a0*a0 + h*h );
  vec3 g;
  g.x  = a0.x  * x0.x  + h.x  * x0.y;
  g.yz = a0.yz * x12.xz + h.yz * x12.yw;
  return 130.0 * dot(m, g);
}

void main() {
    vec4 localPosition = vec4(position, 1.0);
    
    // 1. 静态的垂直褶皱 (Static vertical folds)
    // 使用正弦波产生窗帘自然的褶皱，顶部较密，底部较松散
    float foldFrequency = 8.0;
    float foldDepth = 0.08;
    float folds = sin(localPosition.x * foldFrequency) * foldDepth;
    
    // 2. 风力影响权重 (Wind strength weight)
    // 窗帘顶部固定，底部随风飘动最剧烈
    // uv.y 从 0(底部) 到 1(顶部)
    float windStrength = pow(1.0 - uv.y, 2.5); // 使用指数让顶部更固定
    
    // 3. 随风飘动效果 (Wind blowing effect)
    // 基础大风 (Large gusts)
    float time = uTime * 0.8;
    float gust = sin(localPosition.x * 1.5 + time) * sin(localPosition.y * 1.2 + time * 0.8) * 0.4;
    
    // 细节微风 (Small ripples using noise)
    float noiseFreq = 1.5;
    float ripple = snoise(vec2(localPosition.x * noiseFreq + time * 0.5, localPosition.y * noiseFreq - time * 0.3)) * 0.15;
    
    // 组合所有位移
    float displacement = folds + (gust + ripple) * windStrength;
    
    // 将位移应用到Z轴
    localPosition.z += displacement;
    
    // 窗帘被风吹起时，底部会向内收缩一点点（模拟布料的物理特性）
    localPosition.y += displacement * displacement * 0.2 * windStrength;
    localPosition.x -= displacement * 0.05 * windStrength * sign(localPosition.x);
    
    vec4 modelPosition = modelMatrix * localPosition;
    vec4 viewPosition = viewMatrix * modelPosition;
    vec4 projectedPosition = projectionMatrix * viewPosition;

    gl_Position = projectedPosition;
    vUv = uv;
    vElevation = displacement;
}